import styled from 'styled-components';

export const TextContainer = styled.div`
  /* Same size as the rest of the details text */
  font-size: ${props => props.theme.fontSize.xxxs};
`;
